import type { Observable } from 'rxjs';
import { map, timeout } from 'rxjs/operators';
import type { IHttpClient } from 'utils/http/httpClient.model';

export function sgNewsConnector(httpClient: IHttpClient, timeoutInMillis = 30000) {
  return {
    fetch(region: string): Observable<SgNewsResult> {
      return httpClient
        .getJSON<SgNewsResult>({
          url: 'api/v1/sg-news-events',
          params: { region },
          targetHost: 'AdvisoryBridge',
        })
        .pipe(
          timeout(timeoutInMillis),
          map(r => r.payload),
        );
    },
  };
}

export interface SgNewsResult {
  news: ReadonlyArray<SgNewsCard>;
  events: ReadonlyArray<SgNewsCard>;
}

export interface SgNewsCard {
  id: string;
  name: string;
  description: string;
  content: string;
  image: string;
  creationDate: string;
  tags: string[];
}
